import React from 'react';
import { Container, Typography, Button, Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import CashBox from '../components/CashBox';


function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="lg">
      <Box sx={{ marginTop: isMobile ? 10 : 12, paddingTop: 2 }}>
        {!isMobile && (
          <Typography component="h1" variant="h4" gutterBottom align="center">
            דשבורד
          </Typography>
        )}
        
        <Grid container spacing={3}>
          {/* כפתורי פעולות */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => navigate('/open-bus')}
                fullWidth
                size="large"
              >
                פתח אוטובוס חדש
              </Button>
              
              <Button 
                variant="outlined" 
                color="primary" 
                onClick={() => navigate('/my-buses')}
                fullWidth
                size="large"
              >
                האוטובוסים שלי
              </Button>
            </Box>
          </Grid>

          {/* קופת המזומן */}
          <Grid item xs={12} md={6}>
            <CashBox />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Dashboard;